import React from 'react'

export default function Notice ({children, className=''}) {
  const css = `notice ${className}`
  return <div className={css}>{children}</div>
}
